import { WebApiService } from '../services/web-api-service';
import { Router } from 'aurelia-router';
import { singleton, autoinject } from 'aurelia-framework';
import { Carrier } from "../models/carrier";
import { PhoneValueConverter } from "../resources/value-converters/phone";
import { Contact } from '../models/contact';
import { ContactPhone } from '../models/contact-phone';

@autoinject()
@singleton()
export class RegistrationController {



    public requestId: string = "";
    public initialResponse: string;

    async loadCompanyInfo(requestId: any) {
        try {
            var result = await this.api.get("Registration", "LoadCompanyInfo", { requestId: requestId });
            var resp = JSON.parse(result.response);
            this.initialResponse = resp.status;
            this.carrier = Object.assign(new Carrier(), resp.carrier);
            // this.carrier.contacts[0].phones = [new ContactPhone()];
            this.requestId = requestId;
            if( this.carrier.isTrucksCarrier){
                this.carrier.hasTrucks = true; // assume "Trucks" carrier has access to trucks
            }
        } catch (e) {
            this.carrier = null;
        }
    }

    constructor(private router: Router,
        private api: WebApiService) {
    }

    getEquipment() {
        return this.api.get("Registration", "GetEquipment");
    }

    getHeavyHaulerWeights() {
        return this.api.get("Registration", "GetHeavyHaulerWeights");
    }



    verifyCompanyInfo() {
        //return this.api.get("Registration", "VerifyCompanyInfo", { dotNumber: dotNumber, legalName: legalName, recaptchaResponse: recaptchaResponse })
        //    .then((result) => {
        //        this.carrier = Object.assign(new Carrier(), JSON.parse(result.response));
        //        var emptyContact = new Contact();
        //        emptyContact.phones = [new ContactPhone()];
        //        this.carrier.contacts = [emptyContact];
        //        this.router.navigate("register/details");
        //    });

        if (this.carrier)
            this.router.navigate("/registration/details?id=" + this.requestId);

    }

    submitRegistration(): Promise<void> {

        //format phone #'s
        var converter = new PhoneValueConverter();
        this.carrier.mainPhone = converter.format(this.carrier.mainPhone);
        //this.carrier.ownerOfficerPhone = converter.format(this.carrier.ownerOfficerPhone);
        //this.carrier.administratorPhone = converter.format(this.carrier.administratorPhone);

        //submit carrier registration
        return this.api.post("Registration", "Submit?requestId=" + this.requestId, this.carrier)
            .then(() => {
                //TODO: capture carrier ID
                this.carrier.isSubmitted = true;
            });
    }

    carrier: Carrier;
}
